import { create } from 'zustand'

interface SidebarState {
  isOpen: boolean
  toggle: () => void
  close: () => void
}

export const useSidebarStore = create<SidebarState>()((setState) => ({
  isOpen: false,
  toggle: () => setState((state) => ({ isOpen: !state.isOpen })),
  close: () => setState({ isOpen: false }),
}))
